import {Route, Routes} from "react-router-dom";
import ProjectCard from "../Projects/Projects/ProjectCard";
import ProjectsList from "../Projects/Projects/ProjectsList";
import Offer from "../Projects/Offer/Offer";
import QuoteClientForm from "../Projects/Projects/QuoteClientForm";
import React from "react";
import QuoteLinkNotActive from "../Projects/Projects/QuoteLinkNotActive";
import ProjectsCurrentList from "../Projects/Projects/current/ProjectCurrentList";
import ProjectCurrentItem from "../Projects/Projects/current/ProjectCurrentItem";
import StaffEdit from "../../../../../components/project/StaffEdit";
import EventsEdit from "../../../../../components/project/EventsEdit";
import TechInfoEdit from "../Projects/Projects/current/techInfo/TechInfoEdit";
import LineupEdit from "../Projects/Projects/current/LineUpEdit/LineupEdit";
import SummaryView from "../Projects/Projects/current/Summary/SummaryView";
import MainParticipationView from "../Projects/Projects/MainParticipationView";


const ProjectsRoutes = () => {
    return (<>
        <Routes >
            <Route exact path={"/projects/offer/:key"} element={<Offer />} />
            <Route exact path={"/projects/in-preparation"} element={<ProjectsList />}/>
            <Route exact path={"/projects/in-preparation/:id"} element={<ProjectCard />}/>
            <Route exact path={"/projects/currents-list"} element={<ProjectsCurrentList />}/>
            <Route exact path={"/projects/current/:id"} element={<ProjectCurrentItem />}/>
            <Route
                exact
                path={"/projects/client-quote-accept/:quote_link"}
                element={<QuoteClientForm />}
            />
            <Route exact path={"/project/quote-link/not-active"} element={<QuoteLinkNotActive />}/>
            <Route exact path={"/projects/current/staff-edit/:id"} element={<StaffEdit />}/>
            <Route exact path={"/projects/current/events-edit/:id"} element={<EventsEdit />}/>
            <Route exact path={"/projects/current/tech-info-edit/:id"} element={<TechInfoEdit />}/>
            <Route exact path={"/projects/current/lineup-edit/:id"} element={<LineupEdit />}/>
            <Route exact path={"/projects/current/summary-view/:id"} element={<SummaryView />}/>
            <Route exact path={"/projects/main-participation-view"} element={<MainParticipationView />}/>
            {/*<Route exact path={"/projects/current/summary-view/new-person"} element={<SummaryView />}/>*/}
        </Routes>
    </>)
}

export default ProjectsRoutes

